import { render, staticRenderFns } from "./Informationpage.vue?vue&type=template&id=0d425dd2"
import script from "./Informationpage.vue?vue&type=script&lang=js"
export * from "./Informationpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports